import { type FC } from "react";
import { Button } from "antd";
import { ReactComponent as ArrowLeftIcon } from "../../../../assets/images/keyboard-arrow-left-18.svg";
import { ReactComponent as ArrowRightIcon } from "../../../../assets/images/keyboard-arrow-right-18.svg";
import "./style.less";

export interface StepNavigationProps {
  backLabel: string;
  nextLabel: string;
  onBack?: () => void;
  onNext?: () => void;
  nextDisabled?: boolean;
  className?: string;
}

const StepNavigation: FC<StepNavigationProps> = ({
  backLabel,
  nextLabel,
  onBack,
  onNext,
  nextDisabled = false,
  className,
}) => (
  <div
    className={`rd-step-navigation ${className ?? ""}`}
    data-testid="step-navigation"
  >
    <Button type="text" className="rd-step-navigation__back" onClick={onBack}>
      <ArrowLeftIcon className="rd-step-navigation__icon" aria-hidden />
      <span>{backLabel}</span>
    </Button>
    <Button
      className="rd-step-navigation__next"
      onClick={onNext}
      disabled={nextDisabled}
    >
      <span>{nextLabel}</span>
      <ArrowRightIcon className="rd-step-navigation__icon" aria-hidden />
    </Button>
  </div>
);

export default StepNavigation;
